import { getEventUsersList } from "../../../../helpers/event_user_helper";
import { eventUsersListSuccess } from "./reducer";

export const viewEventUsers = (eventId) => async (dispatch) => {
    let response;
    response = getEventUsersList(eventId);
    const data = await response;
    if (data) {
      dispatch(eventUsersListSuccess(data));
    }
};
